import 'slick-carousel';
import {AbstractCarouselComponent} from "./abstract-carousel";

export class CarouselComponent extends AbstractCarouselComponent {

    getBaseStyleClass() {
        return 'c-carousel';
    };

    getBaseJSClass() {
        return 'js-carousel';
    };

    getSlickParams = () => ({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        dots: false,
        autoplay: false,
        nextArrow: this.$scrollNext,
        prevArrow: this.$scrollPrev,
        appendArrows: this.$controls,
        adaptiveHeight: true,
    });

}
